import { createUser, createUserToken } from "./apiHelper";
import {
  onAccountConnectedCallBack,
  onAccountDisconnectedCallBack,
  onTokenExpiredCallBack,
} from "./callbackFunctions";
import { PHYLLO_CONNECTED_KEY, PHYLLO_TOKEN, PHYLLO_USERID } from "./constants";

export const getElementByKey = (object, value, returnkey) => {
  if (object.length === 0) {
    return null;
  }
  for (var i = 0; i < object.length; i++) {
    if (object[i].name === value) {
      return object[i][returnkey];
    }
  }
};

export const launchSDK = async (setLoader, history, workPlatformId) => {
  setLoader(true);
  try {
    const environment = process.env.REACT_APP_ENV;
    const clientDisplayName = process.env.REACT_APP_PHYLLO_APP;
    const userId = sessionStorage.getItem(PHYLLO_USERID);
    let token = sessionStorage.getItem(PHYLLO_TOKEN);

    if (!userId || !token) {
      const timeStamp = new Date();
      const userId = await createUser(clientDisplayName, timeStamp.getTime());

      const token = await createUserToken(userId);
      sessionStorage.setItem("PhylloUserId", userId);
      sessionStorage.setItem("PhylloToken", token);
    }
    // const phylloConnectURL = await window.PhylloConnectSDK.clientConnect(
    //   env,
    //   userId,
    //   token,
    //   name,
    //   workPlatformId
    // );
    // window.location.href = phylloConnectURL;
    // debugger
    const config = {
      clientDisplayName,
      environment,
      userId,
      token,
      redirect: false,
      workPlatformId,
      singleAccount: true,
    };

    const onExitCallBack = (reason, userId) => {
      console.log(`onExit reason: ${reason}, userId: ${userId}`);
      setLoader(false);
      history.go(0);
    };

    const phylloConnect = window.PhylloConnect.initialize(config);

    phylloConnect.on("exit", onExitCallBack);
    phylloConnect.on("tokenExpired", onTokenExpiredCallBack);
    phylloConnect.on("accountConnected", onAccountConnectedCallBack);
    phylloConnect.on("accountDisconnected", onAccountDisconnectedCallBack);

    phylloConnect.open();
  } catch (err) {
    console.log(err);
    setLoader(false);
  }
};

export const checkConnection = (accounts) => {
  for (let account = 0; account < accounts.data.length; account++) {
    if (accounts.data[account].status === PHYLLO_CONNECTED_KEY) return true;
  }
  return false;
};

// to solve cors error in image
export const getNewImageUrl = (url) => {
  if (url === null) return;
  const urlParts = url.split("/");
  var newUrl = "";
  for (let i = 0; i < urlParts.length; i++) {
    if (i === 2) {
      newUrl +=
        urlParts[i].replaceAll("-", "--").replaceAll(".", "-") +
        atob("LnRyYW5zbGF0ZS5nb29n") +
        "/";
    } else {
      if (i !== urlParts.length - 1) {
        newUrl += urlParts[i] + "/";
      } else {
        newUrl += urlParts[i];
      }
    }
  }
  return encodeURI(newUrl);
};

// to format num ex 12000 -> 12K
export const formatNumber = (num) => {
  function rnd(num, precision) {
    var prec = 10 ** precision;
    return Math.round(num * prec) / prec;
  }
  var abbRev = ['K', 'M', 'B'];
  var base = Math.floor(Math.log(Math.abs(num)) / Math.log(1000));
  var suffix = abbRev[Math.min(abbRev.length - 1, base - 1)];
  base = abbRev.indexOf(suffix) + 1;
  return suffix ? rnd(num / 1000 ** base, 2) + suffix : '' + num;
}

// convert time to hrs min
export const timeConvert=(time)=>{
  let hours = Math.floor(time / 60);  
  let minutes = time % 60;
  return Math.floor(hours) + " hrs " + Math.floor(minutes) + " mins ";   
}

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};
